import NavMenuItem from './NavMenuGroupItem.vue';

export default NavMenuItem;
